import script from "./FormulasIngredientForge.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredientForge.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredientForge.vue?vue&type=style&index=0&id=73e1046e&lang=scss"

const __exports__ = script;

export default __exports__